/* eslint-disable func-names */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
(function (angular) {
  function likesApi($resource, settings) {
    const resource = $resource(`${settings.apiBase}/likes`);

    return resource;
  }

  angular.module("app").service("LikesApi", likesApi);

  likesApi.$inject = ["$resource", "settings"];
})(angular);
